import { getTokenAttributes } from "@bkry/bowline-redux/tokens";
import PropTypes from "prop-types";
import React from "react";
import ReactPlayer from "react-player";
import { useSelector } from "react-redux";

const ChipSelection = ({ chipId, selectedChip, setSelectedChip }, context) => {
  const token = useSelector((state) => getTokenAttributes(state, chipId));
  const animationUrl = JSON.parse(token.metadata)?.animation_url;
  const imageUrl =
    JSON.parse(token.metadata)?.image ||
    "https://metadata.bowline.app/0xsamsunggen3rator/assets/chip/chip.png";

  const tokenName =
    token.name || `${context.t("GEN3 Chip")} #${token?.identifier}`;

  const renderMedia = () => {
    return (
      <>
        {animationUrl ? (
          <ReactPlayer
            width="100%"
            height="auto"
            url={animationUrl}
            controls={false}
            loop={true}
            muted={true}
            playing={true}
            playsinline
            config={{
              file: {
                attributes: {
                  controlsList: "nodownload noplaybackrate",
                  disablePictureInPicture: true,
                },
              },
            }}
          />
        ) : (
          <>
            {imageUrl && (
              <img
                src={imageUrl}
                alt={tokenName}
                className="object-fit-cover"
              />
            )}
          </>
        )}
      </>
    );
  };

  return (
    <div
      onClick={() =>
        selectedChip?.chipId === chipId
          ? setSelectedChip({ chipId: null, tokenIdentifier: null })
          : setSelectedChip({ chipId, tokenIdentifier: token.identifier })
      }
      className={
        selectedChip?.chipId === chipId
          ? "border border-success rounded-4 p-1 cursor-pointer text-primary"
          : "border border-primary border-opacity-10 rounded-4 p-1 cursor-pointer"
      }
    >
      <div className="ratio ratio-1x1 rounded-4 overflow-hidden">
        {renderMedia()}
      </div>
      <div className="mt-3 small">{tokenName}</div>
    </div>
  );
};

ChipSelection.contextTypes = {
  t: PropTypes.func,
};

ChipSelection.propTypes = {
  chipId: PropTypes.string.isRequired,
  selectedChip: PropTypes.object,
  setSelectedChip: PropTypes.func.isRequired,
  chipsContractAddress: PropTypes.string.isRequired,
};

export default ChipSelection;
